export { default as Img200 } from './processed/200/JFK.jpg';
export { default as Img400 } from './processed/400/JFK.jpg';
export { default as Imgthumb } from './processed/thumb/JFK.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/JFK.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/JFK.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      188,
      55,
      100
    ],
    "_population": 5,
    "_hsl": [
      0.943609022556391,
      0.5473251028806584,
      0.47647058823529415
    ]
  },
  "LightVibrant": {
    "_rgb": [
      240,
      218,
      211
    ],
    "_population": 71,
    "_hsl": [
      0.04022988505747127,
      0.4915254237288136,
      0.884313725490196
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      5,
      17,
      37
    ],
    "_population": 743,
    "_hsl": [
      0.6041666666666666,
      0.7619047619047618,
      0.0823529411764706
    ]
  },
  "Muted": {
    "_rgb": [
      116,
      172,
      177
    ],
    "_population": 6,
    "_hsl": [
      0.5136612021857924,
      0.2811059907834101,
      0.5745098039215686
    ]
  },
  "LightMuted": {
    "_rgb": [
      188,
      208,
      171
    ],
    "_population": 1321,
    "_hsl": [
      0.25675675675675663,
      0.2824427480916031,
      0.7431372549019608
    ]
  },
  "DarkMuted": {
    "_rgb": [
      57,
      77,
      89
    ],
    "_population": 812,
    "_hsl": [
      0.5625,
      0.21917808219178078,
      0.28627450980392155
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/JFK.js